import { GeocodeResultDc } from "@evergis/api";
import { createSelector } from "reselect";
import { RootState } from "../reducers";

export const getGeocodeItems = ({ geocode }: RootState): GeocodeResultDc[] => (geocode && geocode.items) || [];

export const isGeocodeActive = createSelector(getGeocodeItems, items => items.length);
